import IconButton from '@mui/material/IconButton';
import { alpha, styled } from '@mui/material/styles';

export const IconActionButtonRoot = styled(IconButton)(({ theme }) => ({
  '&&': {
    width: 39,
    height: 39,
    padding: 0,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '&&:hover': { backgroundColor: theme.palette.primary.main },
  '&&.Mui-disabled': {
    backgroundColor: theme.palette.grey[500],
    color: alpha(theme.palette.common.white, 0.5),
  },
}));
